module.exports = __webpack_public_path__ + "media/images/icon_a7_blue-2da6be5546e916fa24309119bd10e386.png";